import angular from 'angular';

angular.module('commonServices').directive('cxFocusThis', [
  '$parse',
  '$timeout',
  function($parse, $timeout) {
    return {
      // Put a watch on the boolean passed with the attribute and when it is set to true, put focus on the element
      link: function(scope, element, attrs) {
        var model = $parse(attrs.cxFocusThis);
        scope.$watch(model, function(value) {
          if (value === true) {
            $timeout(function() {
              element[0].focus();
            }, 100);
          }
        });
        // To set searching to false on blur (When clicking outside searchfield, the searchbox disappears)
        //element.bind('blur', function () {
        //    console.log('blur');
        //    scope.$apply(model.assign(scope, false));
        //});
      },
    };
  },
]);
